import Main from './containers/main/main.container';
import './App.css';
import Store from './state/store.state';

const App = () => <Store><Main /></Store>

export default App;